<template>
  <div class="cpt-room-notify-list">
    <div
      class="dropdown-container pointer"
      @click.stop="toggleShowDropDown"
    >
      <div class="text">{{ onlyEditNotice ? "房间成员较多，为保证成员更好的使用体验，仅可对公告频道进行通知设置" : "选择一个频道/分组以覆盖房间通知设置" }}</div>
      <div class="icon">
        <i
          class="iconfont"
          :class="[showDropDown ? 'icon-arrow-up' : 'icon-arrow-down']"
        ></i>
      </div>
      <div
        class="dropdown-list"
        v-if="showDropDown"
      >
        <div class="inner-scroller">
          <div
            class="dropdown-item"
            :class="{'disabled': onlyEditNotice && item.data.channel_type !== CHANNEL_TYPES.notice}"
            @click="addItem(item)"
            v-for="item in flattenList"
            :key="item.channel_id"
          >
            <div class="dropdown-item-info">
              <div class="dropdown-item-icon">
                <i
                  class="iconfont"
                  :class="item.icon"
                ></i>
              </div>
              <div class="dropdown-item-title">{{ item.title }}</div>
              <div class="dropdown-item-desc">{{ item.child_cnt !== undefined ? `${item.child_cnt}个频道` : item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-wrapper">
      <div class="list-header">
        <div class="th long">频道/分组</div>
        <div class="th short">所有消息</div>
        <div class="th short">仅@提及</div>
      </div>
      <div class="list-container">
        <template v-if="showList.length">
          <RoomNotifyItem
            v-for="item in showList"
            :key="item.channel_id"
            :item="item"
            :isHighlight="item.channel_id === highlightChannelId"
            :onlyEditNotice="onlyEditNotice"
            @change="(val) => changeValue(item, val)"
            @delete="deleteItem(item)"
            @tip="handleTip"
          />
        </template>
        <div
          v-else
          class="tip"
        >
          添加频道/分组以覆盖房间通知设置
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CHANNEL_TYPES, getChannelIcon } from '@/common/constants/channel';
import {
  ROOM_NOTIFY_SETTING_ENUM,
  ROOM_NOTIFY_SETTING_TYPES,
} from '@/common/constants/room';
import { setChannelSettings, getFullChannelList } from '_api/channel';
import { findChannelSync } from '_js/find-channel';
import EventBus from '_lib/EventBus';
import RoomNotifyItem from './RoomNotifyItem.vue';
export default {
  name: 'RoomNotifyList',
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
    roomId: {
      type: String,
    },
    channels: {
      type: Array,
      default: () => [],
    },
    onlyEditNotice: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    RoomNotifyItem,
  },
  data() {
    return {
      showDropDown: false,
      tempList: [],
      channelList: [],
      highlightChannelId: '',
      ROOM_NOTIFY_SETTING_ENUM,
      CHANNEL_TYPES,
    };
  },
  computed: {
    flattenList() {
      const flatChannels = [];
      const handlePushChannel = (data, list) => {
        const channel = data.data;
        if (!channel) return false;
        const notifySetting = this.$unread.getNotifySetting(
          {
            channel_id: data.channel_id,
            room_id: this.roomId,
          },
          true,
          false,
        );
        data.notifySetting = notifySetting;
        list.push(data);
        return true;
      };
      // 过滤 获取只有文字和公告频道的列表
      this.channelList.forEach((channel, index) => {
        if (channel.channel_type === CHANNEL_TYPES.group) {
          handlePushChannel(
            {
              channel_id: channel.channel_id,
              type: 'group',
              title: channel.channel_name,
              // desc: channel_list.length + '个频道',
              child_cnt: 0,
              icon: 'icon-file',
              data: channel,
            },
            flatChannels
          );
        } else {
          let parentChannel
          if(channel.parent_id) {
            parentChannel = flatChannels.find(item => item.channel_id == channel.parent_id)
            if(parentChannel) {
              parentChannel.child_cnt++
            }
          }
          handlePushChannel(
            {
              channel_id: channel.channel_id,
              type: 'channel',
              title: channel.channel_name,
              desc: parentChannel?.title ?? '', // 父频道名称
              icon: channel.icon_class,
              data: channel,
            },
            flatChannels
          );
        }
      });
      return flatChannels;
    },
    showList() {
      const showList = [];
      const handlePushChannel = (data, list) => {
        const channel = data.data;
        if (!channel) return false;
        if (!channel.notify_setting) return false;
        list.push(data);
        return true;
      };
      // 过滤 获取只有文字和公告频道的列表
      // const filterTextChannel = (list) => {
      //   return list.filter((item) => {
      //     return [CHANNEL_TYPES.text, CHANNEL_TYPES.notice].includes(
      //       item.channel_type
      //     );
      //   });
      // };
      this.channelList.forEach((channel, index) => {
        // 如果是频道组并且没被折叠的话，将channel_list push进去
        if (channel.channel_type === CHANNEL_TYPES.group) {
          handlePushChannel(
            {
              channel_id: channel.channel_id,
              type: 'group',
              title: channel.channel_name,
              child_cnt: 0,
              // desc: channel_list.length + '个频道',
              icon: 'icon-file',
              data: channel,
            },
            showList
          );
        } else {
          let parentChannel
          if(channel.parent_id) {
            parentChannel = showList.find(item => item.channel_id == channel.parent_id)
          }
          if(parentChannel) {
            parentChannel.child_cnt++
          }
          handlePushChannel(
            {
              channel_id: channel.channel_id,
              type: 'channel',
              title: channel.channel_name,
              desc: '',
              icon: channel.icon_class,
              data: channel,
            },
            showList
          );
        }
      });
      const tempList = this.tempList.map(item => {
        return {
          ...item,
          tempValue: item.notifySetting.parent_notify_type
        }
      });

      return showList.concat(tempList);
    },
    ...mapGetters(['cur_room_data', 'setting_data', 'all_notify_settings']),
  },
  watch: {
    highlightChannelId(v) {
      if (v) {
        this._timer = setTimeout(() => {
          document.addEventListener('click', this.removeHighlight);
          clearTimeout(this._timer);
        });
      } else {
        document.removeEventListener('click', this.removeHighlight);
      }
    },
    channels: {
      handler(v) {
        this.channelList = v.filter(item => [CHANNEL_TYPES.text, CHANNEL_TYPES.notice, CHANNEL_TYPES.group].includes(item.channel_type))
        this.channelList.forEach(item => {
          item.icon_class = getChannelIcon(item)
        })
      },
      immediate: true
    }
  },
  mounted() {
    EventBus.$on('Update_Room_Notify', this.updateRoomNotifyHandler);
    EventBus.$on(
      'Update_Channel_Notify_Setting',
      this.updateChannelNotifySettingHandler
    );
    document.addEventListener('click', this.handleCloseDropDown);
  },
  beforeDestroy() {
    EventBus.$off('Update_Room_Notify', this.updateRoomNotifyHandler);
    EventBus.$off(
      'Update_Channel_Notify_Setting',
      this.updateChannelNotifySettingHandler
    );
    document.removeEventListener('click', this.handleCloseDropDown);
    clearTimeout(this._timer);
  },
  methods: {
    addItem(item) {
      if(this.onlyEditNotice && item.data.channel_type !== CHANNEL_TYPES.notice) {
        this.handleTip();
        return
      }
      const isExist = this.getIsInShowList(item);
      if (isExist) {
        this.highlightChannelId = item.channel_id;
      } else {
        this.tempList.push(item);
      }
    },
    async changeValue(item, value) {
      const {
        data: { status, result },
      } = await setChannelSettings(
        {},
        {
          channel_id: item.channel_id,
          room_id: this.roomId,
          setting: 'notify_setting',
          value,
        }
      );
      if (status == 'ok') {
        // 如果在temp里面则删除对应的item
        this.tempList = this.tempList.filter(
          (tempItem) => tempItem.channel_id !== item.channel_id
        );
        const channel = findChannelSync(item.channel_id, this.channelList)
        this.$set(channel, 'notify_setting', value)
      }
    },
    deleteItem(item) {
      const isTempItem =
        this.tempList.findIndex((i) => i.channel_id === item.channel_id) !== -1;
      if (isTempItem) {
        this.tempList = this.tempList.filter(
          (tempItem) => tempItem.channel_id !== item.channel_id
        );
        return;
      }
      if (this.setting_data.remember_delete_notify) {
        this.changeValue(item, ROOM_NOTIFY_SETTING_ENUM['extend']);
      } else {
        let parentNotifyType;

        if (item.data.parent_id) {
          const parentNotifySetting =
            this.$unread.getNotifySetting(
              {
                room_id: this.roomId,
                channel_id: item.data.parent_id,
              },
              true,
              false
            ) || DEFAULT_NOTIFY_SETTING;
          parentNotifyType = parentNotifySetting.notify_type;
        } else {
          parentNotifyType =
            this.all_notify_settings[this.roomId]?.notify_type || 1;
        }

        const text = Object.values(ROOM_NOTIFY_SETTING_TYPES).find(
          (item) => item.key == parentNotifyType
        ).label;
        EventBus.$dynamic('DeleteChannelNotifyDialog', {
          text,
          confirmCb: () => {
            this.changeValue(item, ROOM_NOTIFY_SETTING_ENUM['extend']);
          },
        });
      }
    },
    toggleShowDropDown() {
      this.showDropDown = !this.showDropDown;
    },
    getIsInShowList(item) {
      const index = this.showList.findIndex(
        (channel) => channel.channel_id === item.channel_id
      );
      return index !== -1;
    },
    removeHighlight() {
      this.highlightChannelId = '';
    },
    updateRoomNotifyHandler() {
      this.tempList = this.tempList.map((temp) => {
        if (temp.notifySetting.extend_type === '房间') {
          const newSetting = this.$unread.getNotifySetting(
            {
              channel_id: temp.data.channel_id,
              room_id: this.roomId,
            },
            true,
            false,
          );
          temp.notifySetting = newSetting;
        }
        return temp;
      });
    },
    updateChannelNotifySettingHandler(subChannelIds) {
      const tempList = this.tempList;
      for (let i = 0; i < tempList.length; i++) {
        const tempItem = tempList[i];
        if (subChannelIds.includes(tempItem.channel_id)) {
          const newNotifySetting = this.$unread.getNotifySetting(
            {
              channel_id: tempItem.channel_id,
              room_id: this.roomId,
            },
            true,
            false,
          );
          tempItem.notifySetting = newNotifySetting;
        }
      }
      this.tempList = tempList;
    },
    handleCloseDropDown() {
      this.showDropDown = false;
    },
    handleTip() {
      this.$toast.error(
        '房间成员较多，为保证成员更好的使用体验，仅可对公告频道进行通知设置'
      );
    },
  },
};
</script>

<style lang="scss">
.cpt-room-notify-list {
  .dropdown-container {
    position: relative;
    display: flex;
    align-items: center;
    padding: 11px 12px;
    margin-bottom: 8px;
    gap: 8px;
    align-self: stretch;
    border-radius: 5px;
    background: $d-op-s2;
    .text {
      flex: 1;
      overflow: hidden;
      color: $d-tx-4;
      text-overflow: ellipsis;

      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.14px;
    }
    .icon {
      & > .iconfont {
        color: $d-tx-3;
        font-size: 8px;
      }
    }
    .dropdown-list {
      position: absolute;
      top: 42px;
      left: 0;
      right: 0;
      z-index: 1;
      display: flex;
      max-height: 310px;
      padding: 8px;
      flex-direction: column;
      align-items: flex-start;

      border-radius: 5px;
      background: $d-fl-pp;
      overflow-y: auto;
      overflow-x: hidden;

      /* 弹层阴影 */
      box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
      .inner-scroller {
        width: 100%;
      }
      .dropdown-item {
        display: flex;
        width: 100%;
        height: 32px;
        padding: 6px 8px;
        padding-right: 30px;
        align-items: center;
        flex-shrink: 0;
        align-self: stretch;
        cursor: pointer;
        &.disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        .dropdown-item-info {
          display: flex;
          flex: 1;
          align-items: center;
        }
        .dropdown-item-icon {
          > .iconfont {
            font-size: 16px;
            color: $d-tx-4;
          }
        }
        .dropdown-item-title {
          margin-left: 6px;
          color: $d-tx-2;
          text-align: center;

          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.14px;
          max-width: 140px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .dropdown-item-desc {
          margin-left: 4px;
          color: $d-tx-4;

          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0.12px;
          max-width: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .dropdown-item-operation {
          margin-right: 0;
          display: flex;
          align-items: center;
          .dropdown-item-operation-item {
            display: flex;
            padding: 0px 27px;
            justify-content: center;
            align-items: center;
            gap: 4px;
            align-self: stretch;
            > .icon-toast-success {
              color: $d-bd-tx;
            }
          }
        }
      }
    }
  }
  .list-wrapper {
    border-radius: 5px;
    background: $d-fl-2;
    .list-header {
      display: flex;
      padding-right: 34px;
      align-items: center;
      align-self: stretch;
      border-bottom: 1px solid $d-ln-2;
      .th {
        color: $d-tx-3;
        text-align: center;

        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.12px;
        display: flex;
        align-items: center;
        &.long {
          height: 40px;
          padding-left: 12px;
          gap: 1px;
          flex: 1 0 0;
        }
        &.short {
          width: 72px;
          height: 40px;
          justify-content: center;
        }
      }
    }
    .list-container {
      .tip {
        display: flex;
        height: 48px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
        flex: 1 0 0;
        align-self: stretch;
        border: 1px dashed $ct-bl-4;
        border-radius: 0 0 5px 5px;

        color: $d-tx-3;
        text-align: center;

        font-size: 13px;
        line-height: 18px;
        letter-spacing: 0.13px;
      }
    }
  }
}
</style>
